<script lang="ts">
  import VirtualScroll from "svelte-virtual-scroll-list";
  import { getContext } from "svelte";
  import type { POI } from "../poi";
  import { ConnectMapApp } from "../app";

  export function keyEvent (event: KeyboardEvent) {
    switch (event.key) {
      case 'ArrowUp': pointer && pointer--; break;
      case 'ArrowDown': pointer < items.length && pointer++; break;
      case 'Enter': items[pointer] && select(items[pointer]); break;
    }
  }

  const app = getContext<ConnectMapApp<any>>('app');
  
  const { state } = app;
  const { list_filtered } = app.poi_data;

  let items: POI[];
  let pointer = -1;

  $: {
    items = $list_filtered;
    pointer = -1;
  }


  function name (poi: POI) {
    return poi.label;
  }

  function floor (poi: POI) {
    return poi.floor;
  }
  
  function select (poi: POI) {
    app.state.selectPOI(poi);
  }
  
</script>


{#if items.length}
  <VirtualScroll
    data={items}
    key="key"
    let:data
    let:index>
    <div class="poi-row" class:pointer={index == pointer}
      on:click={() => select(data)} 
      on:keyup={() => select(data)}>
      <strong class="vgwv-search-result__title">{name(data)}</strong>
      <div class="vgwv-search-result__floor">{floor(data)}</div>
    </div>
  </VirtualScroll>
{/if}

<style>

  .vgwv-search-results--expanded {
    height: 78%; /* For IE11 */
    height: calc(100% - 50px - var(--vgwv-p16));
    padding-top: var(--vgwv-p24);
    transition: height .3s .2s ease, padding .3s .2s ease;
  }

  .poi-row {
    padding: var(--_p1) var(--_p2);
    border-bottom: 1px solid #eee;
  }

  .pointer {
    background-color: salmon;
  }

</style>
